import Table from 'further-ui/components/Table';
import { useHasPermissions } from 'hooks/ui/usePermissions';
import { RolePermission } from 'further-types/admin-user-role';
import { useFilters, usePagination } from 'further-ui/hooks';
import PageFilters, { Filter } from 'components/new/PageFilters';
import api from 'lib/trpcClient';
import { VEHICLE_ADD } from 'adminConstants/routes';
import SearchField from 'further-ui/components/SearchField';
import Page from 'components/new/Page';

const Vehicles: React.FC = () => {
  const [createPermission] = useHasPermissions([
    RolePermission.LpCreateVehicle,
  ]);
  const pagination = usePagination(
    {
      id: 'vehicles-table',
      order: 'desc',
      orderBy: 'vehicleName',
    },
    ['vehicleName'],
  );
  const { filters, handleChangeFilters } = useFilters('vehicles-table', {
    defaultFilters: {
      search: '',
    },
    onFiltersChange: pagination.toFirstPage,
  });

  const { data, isFetching } = api.vehicle.listVehiclesPaginated.useQuery({
    ...pagination.properties,
    search: filters.search,
  });

  const columns = [
    {
      label: 'Vehicle name',
      key: 'vehicleName',
    },
    {
      label: 'Base currency',
      key: 'baseCurrency',
    },
  ];

  const actions = [
    {
      hidden: !createPermission,
      label: 'Add Vehicle',
      link: VEHICLE_ADD,
    },
  ];

  return (
    <Page heading="Vehicles" actions={actions} spacing="lg">
      <PageFilters>
        <Filter size="md">
          <SearchField
            placeholder="Search by vehicle name"
            value={filters.search}
            onSearch={(query) => {
              handleChangeFilters({ search: query });
            }}
            autoSearchOnDebounce
            allowEmptyQuery
            fullWidth
          />
        </Filter>
      </PageFilters>

      <Table
        columns={columns}
        rows={data?.result ?? []}
        pagination={pagination}
        rowsTotalCount={data?.total}
        isLoading={isFetching}
        emptyMessage="No vehicles found"
      />
    </Page>
  );
};

export default Vehicles;
